import { createActionGroup, emptyProps } from '@ngrx/store';

export const PAGE = createActionGroup({
  source: 'Page',
  events: {
    'App component initialized': emptyProps(),
    'Order confirmation page launched': emptyProps(),
  },
});
